export const CLOSED_NOTEHEAD_PATH =
  "M224 136c53 0 105 -26 105 -86c0 -71 -57 -122 -104 -150" +
  "c-36 -22 -78 -36 -120 -36c-53 0 -105 26 -105 86" +
  "c0 71 58 122 105 150c36 22 77 36 119 36z";

export const OPEN_NOTEHEAD_PATH =
  "M318 67c0 25 -21 42 -43 42c-4 0 -9 -1 -13 -2c-31 -9 -79 -41 -117 -65s-85 -55 -106 -80c-7 -8 -11 -19 -11 -29c0 -25 21 -42 43 -42c4 0 8 1 12 2c31 9 79 41 117 65s86 55 107 80c7 8 11 19 11 29zM267 136c44 0 79 -20 79 -68c0 -19 -6 -38 -12 -57c-13 -37 -32 -73 -65 -95c-54 -36 -115 -52 -190 -52c-44 0 -79 20 -79 68c0 19 6 38 12 57c13 37 31 73 64 95c54 36 116 52 191 52z";

export const WHOLE_NOTEHEAD_PATH =
  "M215 112c-50 0 -69 -43 -69 -88c0 -77 57 -136 134 -136" +
  "c50 0 69 43 69 88c0 77 -57 136 -134 136zM495 0c0 -43 -35" +
  " -76 -73 -97c-53 -30 -113 -41 -174 -41s-122 11 -175 41" +
  "c-38 21 -73 54 -73 97s35 76 73 97c53 30 114 41 175 41" +
  "s121 -11 174 -41c38 -21 73 -54 73 -97z";
